import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const overviewRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Overview" },
    children: [
      {
        index: true,
        lazy: async () => {
          const { Homepage } = await import("./homepage");
          return { Component: Homepage };
        },
      },
    ],
  },
];
